import moment from "moment";
import { format, subHours } from "date-fns";
import { capitalizeFirstLetter } from "./CapitalizeFirstLetter";
import formatCep from "./FormatCep";
import { DeliveryTypeTitleEnum } from "../enums/DeliveryTypeEnum";

const collectsCSVFormat = collects => {
  const csvCollectsData = [];

  collects.map(row => {
    const rowData = {
      Coleta: row?.id || "",
      Cliente: row?.user.userData[1].Value || "",
      "Quantidade de Objetos":
        row.shippings.length !== 0
          ? `${row.shippings.length} objeto${row.shippings.length > 1 ? "s" : ""}`
          : 0,
      "Data Criação":
        moment(row.created_at)
          .subtract(3, "hours")
          .format("DD/MM/YYYY") || "",
      "Data Agendada": format(new Date(row.collectDate), "dd/MM/yyyy"),
      "Período Coleta": row.collectPeriod === "Morning" ? "Manhã" : "Tarde",
      Status: row.collectsStatus?.name
    };

    return csvCollectsData.push(rowData);
  });

  return csvCollectsData;
};

const safeFormat = (value, pattern) => {
  if (!value) return "";
  const date = value instanceof Date ? value : new Date(value);
  return isNaN(date.getTime()) ? "" : format(date, pattern);
};

const shippingsCSVFormat = (shippings, type, isDeleted = false) => {
  const csvShippingsData = [];

  shippings.map(row => {
    const expedidoDate = row?.correiosRastreio?.find(t => t?.[0]?.toLowerCase()?.includes("expedido"))?.[1]?.data;
    const transitoDate = row?.correiosRastreio?.find(t => t?.[0]?.toLowerCase()?.includes("trânsito"))?.[1]?.data;
    const statusId = row?.status?.id;

    const rowData = {
      "Código da etiqueta": row.sro || "",
      Envio: row?.name || "",
      Pedido: row?.orderCode || row?.orderNumber || "",
      Coleta: row.idCollect || "",
      "Data Criação": row?.created_at ? safeFormat(subHours(new Date(row.created_at), 3), "dd/MM/yyyy HH:mm") : "",
      "Data expedido":
        row.isValidated && expedidoDate
          ? safeFormat(expedidoDate, "dd/MM/yyyy HH:mm")
          : "",
      "Data em trânsito":
        statusId > 3 &&
          statusId !== 14 &&
          statusId !== 17 &&
          transitoDate
          ? safeFormat(transitoDate, "dd/MM/yyyy HH:mm")
          : "",
      "Previsão Entrega": safeFormat(row?.previewDate, "dd/MM/yyyy"),
      "Data Entrega":
        statusId === 10 || statusId === 8
          ? safeFormat(row?.deliveredDate, "dd/MM/yyyy HH:mm")
          : "",
      Cliente: row.user?.userData?.[1]?.Value || "",
      Remetente:
        type.value === "normal" ? row.origin?.name : row.destination?.name,
      "CEP de Origem": formatCep(row?.origin?.zip),
      Destinatário:
        type.value === "normal" ? row.destination?.name : row.origin?.name,
      "CEP de Destino": formatCep(row?.destination?.zip),
      "Bairro de Destino": formatCep(row?.destination?.district),
      "Cidade de Destino": row.destination?.city,
      "UF de Destino": row.destination?.state,
      Status: capitalizeFirstLetter(row.status?.name) || "",
      "Valor do Frete": Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
      }).format(row?.price),
      "Tipo de Envio": DeliveryTypeTitleEnum[row?.type] ?? "",
      ...(isDeleted && { "Data de deleção": safeFormat(row?.deleted_at, "dd/MM/yyyy HH:mm") })
    };
    return csvShippingsData.push(rowData);
  });

  return csvShippingsData;
};

const routesCSVFormat = routes => {
  const csvRoutesData = [];

  routes.map(row => {
    const started = row.started_at ? moment(row.started_at).format("DD/MM/YYYY - HH:mm") : "";
    const finalized = row.finalized_at ? moment(row.finalized_at).format("DD/MM/YYYY - HH:mm") : "";
    const kms = row?.kms_traccar ? `~ ${row?.kms_traccar?.toFixed(2)} km` : "--";

    let totalValue = 0;
    let totalValueDelivered = 0;
    let totalDelivered = 0;
    let totalRouteShipping = 0;

    if (row?.routeShipping?.length) {
      row.routeShipping.forEach((rs) => {
        totalValue += rs?.shipping?.price || 0;
        totalRouteShipping += 1;

        if (rs.id_own_delivery_status === 11) {
          totalValueDelivered += rs?.shipping?.price || 0;
          totalDelivered += 1;
        }
      });
    }

    if (row?.ownCollectRoutes?.length) {
      row.ownCollectRoutes.forEach((oc) => {
        totalRouteShipping += 1;
        if (oc.id_own_delivery_status === 11) {
          totalDelivered += 1;
        }
      });
    }

    const rowData = {
      Rota: row?.id || "",
      "Objetos Entregues": `${totalDelivered} de ${totalRouteShipping}`,
      "Data Criação":
        moment(row.created_at)
          .subtract(3, "hours")
          .format("DD/MM/YYYY") || "",
      "Motorista": capitalizeFirstLetter(row?.driver?.name) || "",
      Status: row.status?.name,
      Inicio: started,
      Fim: finalized,
      "Kms Percorrido": kms,
      "Valor Total": new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
      }).format(totalValue),
      "Valor Total Entregue": new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
      }).format(totalValueDelivered)
    };

    return csvRoutesData.push(rowData);
  });

  return csvRoutesData;
};

export { collectsCSVFormat, shippingsCSVFormat, routesCSVFormat };